import { Link } from 'react-router-dom';
import { ChevronRight, Music2 } from 'lucide-react';
import { AppShell } from '@/components/layout/AppShell';
import { ModeCard } from '@/components/ModeCard';
import { t } from '@/i18n';

/** Four modes. Not fifteen. The tuner sits below them: a utility, not a mode. */
export function TrainingModesPage() {
  return (
    <AppShell title={t('modes.title')} showBack>
      <div className="stack-16">
        <ModeCard mode="chordChange" size="large" />
        <ModeCard mode="cleanChord" size="large" />
        <ModeCard mode="rhythm" size="large" />
        <ModeCard mode="strumming" size="large" />
        <Link to="/tuner" className="mode-card mode-card--compact">
          <span className="mode-card__badge mode-card__badge--orange">
            <Music2 size={24} aria-hidden="true" strokeWidth={2.2} />
          </span>
          <span className="mode-card__text">
            <span className="mode-card__title">{t('tuner.title')}</span>
            <span className="mode-card__hint">{t('tuner.entryHint')}</span>
          </span>
          <ChevronRight className="mode-card__chevron" size={22} aria-hidden="true" />
        </Link>
      </div>
    </AppShell>
  );
}
